import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Container, Form, Label, SubContainer, Title } from "./styles";
import { Input } from "../../components/Input/styles";
import { Button } from "../../components/Button/styles";
import { MiniErrors } from "../../components/MiniErrors/styles";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import { useState } from "react";
import { WrongLogin } from "../../components/WrongLogin/styles";

function Login({ setUser, isLogged, setIsLogged }) {
  const [wrongLogin, setWrongLogin] = useState();
  const history = useHistory();
  const formSchema = yup.object().shape({
    email: yup
      .string()
      .required("E-mail obrigatório")
      .email("Formato de E-mail incorreto"),
    password: yup.string().required("Senha obrigatória"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmitFunction = (data) => {
    api
      .post("/sessions", data)
      .then((res) => {
        localStorage.setItem("token", res.data.token);
        setIsLogged(true);
        setUser(res.data.user);
        history.push("/home");
      })
      .catch((err) => {
        setWrongLogin(true);
        console.log(err);
      });
  };

  return (
    <>
      <Container>
        <SubContainer height="650px">
          <Title color="#FF577F" fontSize="30px">
            Kenzie Hub
          </Title>
          <Form onSubmit={handleSubmit(onSubmitFunction)}>
            <Title color="white" fontSize="22px">
              Login
            </Title>
            <div>
              <Label htmlFor="email">
                E-mail{" "}
                {errors.email && (
                  <MiniErrors> {errors.email.message}</MiniErrors>
                )}
              </Label>
              <Input
                name="email"
                placeholder="Digite seu e-mail."
                {...register("email")}
              />
            </div>
            <div>
              <Label htmlFor="password">
                Senha{" "}
                {errors.password && (
                  <MiniErrors> {errors.password.message}</MiniErrors>
                )}
              </Label>
              <Input
                name="password"
                placeholder="Digite sua senha."
                {...register("password")}
              />
            </div>
            {wrongLogin && <WrongLogin>Credenciais Incorretas</WrongLogin>}
            <Button type="submit" fontSize="20px" backgroundColor="#FF577F">
              Entrar
            </Button>
          </Form>
          <div
            style={{
              height: "130px",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              // justifyContent: "space-around",
              alignItems: "center",
              backgroundColor: "#212529",
              borderBottomLeftRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          >
            <Title
              style={{ marginTop: "15px" }}
              color="#868E96"
              fontSize="17px"
            >
              Ainda não possui uma conta?
            </Title>
            <Button
              onClick={() => history.push("/signup")}
              fontSize="20px"
              backgroundColor="#868E96"
            >
              Cadastre-se
            </Button>
          </div>
        </SubContainer>
      </Container>
    </>
  );
}

export default Login;
